import _ from 'lodash'

export const clone = (foo) => {
	let bar = {}
	const keys = Object.keys(foo)
	keys.forEach((key) => {
		let value = foo[key]
		if (value !== null) {
			if (typeof value === 'object') {
				bar[key] = (value instanceof Array) ? arrayClone(value) : clone(value)
			} else {
				bar[key] = foo[key]
			}
		}
	})

	return bar
}

export const cloneDeep = (foo) => {
	return _.cloneDeep(foo)
}

export const arrayClone = (foo) => {
	if (foo.length > 0) {
		return foo.map((item) => { return clone(item) })
	} else {
		return []
	}
}

const iRobot = {
	clone: clone,
	arrayClone: arrayClone,
	cloneDeep: cloneDeep
}

export const VueRobot = {
	install: function (Vue) {
		Vue.prototype.$iRobot = iRobot
	}
}



// WEBPACK FOOTER //
// ./src/common/services/iRobot.js